import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { TextField, FormControlLabel, Checkbox } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { UserCreate } from '../../../../interfaces/User/UserWMS'
import { postUserWMS } from '../api'

export interface UserCreateHandle {
  submitForm: () => void
}

interface UserCreateProps {
  onSuccess: (message: string) => void
  onError: (message: string) => void
}

const initialValues = { userName: '', userAlias: '', active: true }

export const UserCreateModal = forwardRef<UserCreateHandle, UserCreateProps>(
  ({ onSuccess, onError }, ref) => {
    const [values, setValues] = useState(initialValues)
    const [errors, setErrors] = useState<{ userName?: string; userAlias?: string }>({})
    const [loading, setLoading] = useState(false)

    useImperativeHandle(ref, () => ({ submitForm: handleSubmit }))

    const validate = () => {
      const newErrors: typeof errors = {}
      if (!values.userName.trim()) newErrors.userName = 'Debe ingresar un email.'
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.userName.trim())) newErrors.userName = 'El email no es válido.'
      else if (values.userName.length > 150) newErrors.userName = 'Máximo 150 caracteres.'
      if (!values.userAlias.trim()) newErrors.userAlias = 'Debe ingresar un nombre.'
      else if (values.userAlias.length > 80) newErrors.userAlias = 'Máximo 80 caracteres.'
      setErrors(newErrors)
      return Object.keys(newErrors).length === 0
    }

    const handleSubmit = () => {
      if (!validate()) return

      const payload: UserCreate = {
        userName: values.userName.trim(),
        userAlias: values.userAlias,
        active: values.active,
        zones: []
      }

      setLoading(true)
      postUserWMS(payload)
        .then(() => onSuccess('Usuario creado correctamente'))
        .catch(({ response }) =>
          onError(response?.data?.message || 'Hubo un error al intentar crear el usuario.')
        )
        .finally(() => setLoading(false))
    }

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            name='userName'
            label='Email'
            fullWidth
            variant='outlined'
            value={values.userName}
            onChange={(e) => setValues({ ...values, userName: e.target.value })}
            error={Boolean(errors.userName)}
            helperText={errors.userName}
            disabled={loading}
            required
          />
        </Grid>

        <Grid size={12}>
          <TextField
            name='userAlias'
            label='Nombre'
            fullWidth
            variant='outlined'
            value={values.userAlias}
            onChange={(e) => setValues({ ...values, userAlias: e.target.value })}
            error={Boolean(errors.userAlias)}
            helperText={errors.userAlias}
            disabled={loading}
            required
          />
        </Grid>

        <Grid size={12}>
          <FormControlLabel
            control={
              <Checkbox
                name='active'
                checked={values.active}
                onChange={(e) => setValues({ ...values, active: e.target.checked })}
                color='primary'
                disabled={loading}
              />
            }
            label='Activo'
          />
        </Grid>
      </Grid>
    )
  }
)
